<template>
  <div class="page--full vision bg-white">
    <el-row type="flex" class="row--full">
      <el-col :sm="15" class="vision__header">
        <!-- <transition name="fadeInUp"> -->
        <h1 class="header__wrapper" v-if="showContentByPaging">
          <span class="header">
            Soda Labs is a<br />hardware-as-a-service<br />venture builder
          </span>
        </h1>
        <!-- </transition> -->
        <!-- <transition name="fadeInUp"> -->
        <el-row :gutter="20" v-if="showContentByPaging">
          <el-col v-for="(item, index) in visions" :key="index" :md="8">
            <div class="block">
              <div class="is-flex middle start">
                <img class="block__image" :src="item.src" :alt="item.alt" width="72" height="72" />
                <div class="block__content">{{ item.text }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- </transition> -->
      </el-col>
      <el-col :sm="9" class="hidden-xs-only vision__image">
        <ImageWithLoader
          :src="require('@/assets/images/vision/vision.jpg')"
          :preloadSrc="require('@/assets/images/vision/vision_preload.png')"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';
import ImageWithLoader from '@/components/ImageWithLoader.vue';

export default {
  components: {
    ImageWithLoader,
  },
  mixins: [contentAnimation],
  data() {
    return {
      visions: [
        {
          src: require('@/assets/images/vision/idea.svg'),
          alt: 'Idea',
          text: 'We build new companies from the ground up, based on internal ideas',
        },
        {
          src: require('@/assets/images/vision/cloud.svg'),
          alt: 'Cloud',
          text: 'We combine the captive nature of hardware with SaaS revenues',
        },
        {
          src: require('@/assets/images/vision/hardware.svg'),
          alt: 'Hardware',
          text: 'We drastically decrease the cost and time to product market fit for hardware',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.vision {
  &__header {
    overflow: hidden;
    padding: 5rem 2rem 0;
    @media (min-width: $sm) {
      padding: 12% 10% 0 12%;
    }
    @media (min-width: $xl) {
      padding: 12% 10% 0 10%;
    }
    @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
      (max-width: $xs) {
      padding-top: 3rem;
    }
  }
  &__image {
    @media (min-width: $sm) {
      padding: 1.25rem;
    }
    @media (min-width: $xl) {
      padding: 1.875rem;
    }
    .vue-load-image {
      height: 100%;
      /deep/ img {
        height: 100%;
      }
    }
  }
}

.header {
  &__wrapper {
    @media (min-width: $xl) {
      margin-bottom: 3rem;
    }
  }
}

.block {
  margin-top: 30px;
  @media (min-width: $sm) {
    max-width: 10rem;
  }
  @media (min-width: $xl) {
    max-width: 15rem;
  }
  @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
    (max-width: $xs) {
    margin-top: 1.5rem;
  }
  .block__content {
    opacity: 0.7;
  }
  .block__image {
    margin: 0 24px 0 0;
    @media (min-width: 1024px) {
      margin: 0 0 24px;
    }
  }
  .is-flex {
    flex-wrap: nowrap;
  }
  @media (min-width: 1024px) {
    .is-flex {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.5s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.5s reverse;
}
</style>
